<template>
  <fragment>
    <g
      id="Mouth_A-13-1-1"
      v-if="data.value === 'type-1' && data.position === 'b'"
    >
      <path
        id="_-12"
        d="M187.53,225.24c-8.95,3.68-18.93-.15-28.07-.1-9.2-.11-19.37,3.98-28.28,.12-1.91-.98-.29-3.46,1.69-2.54,3.49,2.13,8.4,1.85,12.63,1.56,4.55-.36,9.15-1.11,13.94-1.13,4.82-.06,9.44,.85,13.95,1.25,4.36,.41,8.89,.31,12.72-1.57,1.89-.87,3.39,1.61,1.41,2.41h0Z"
        fill="#b17f5e"
      />
    </g>
    <g
      id="Mouth_A-13-1-2"
      v-if="data.value === 'type-2' && data.position === 'b'"
    >
      <path
        id="_-13"
        d="M181.36,225.41c-6.87,3.29-14.53-.14-21.54-.09-7.07-.09-14.87,3.56-21.71,.11-1.47-.87-.22-3.1,1.3-2.27,2.68,1.9,6.45,1.66,9.7,1.39,3.49-.32,7.02-.99,10.7-1.02,3.7-.06,7.24,.76,10.71,1.12,3.35,.37,6.82,.28,9.77-1.4,1.45-.78,2.6,1.44,1.09,2.16h0Z"
        fill="#b17f5e"
      />
    </g>
    <g
      id="Mouth_A-13-1-3"
      v-if="data.value === 'type-3' && data.position === 'b'"
    >
      <path
        d="M174.04,225.01c-.13-.59-.65-1.02-1.22-1.02-.21,0-.42,.06-.62,.16-1.12,.64-2.45,.94-4.08,.94-.57,0-1.17-.04-1.84-.11-.73-.07-1.45-.18-2.21-.29-1.42-.21-2.89-.42-4.41-.42h-.24c-1.57,.01-3.1,.2-4.58,.39-.74,.09-1.51,.19-2.26,.26-.72,.06-1.43,.11-2.15,.11-1.63,0-2.8-.29-3.67-.91-.02-.01-.03-.02-.05-.03-.21-.12-.44-.18-.66-.18-.58,0-1.11,.41-1.27,1.01-.16,.58,.08,1.17,.61,1.48,1.36,.69,2.85,1.01,4.6,1.01,1.59,0,3.21-.26,4.78-.52,1.56-.25,3.04-.5,4.49-.5h.26c1.44,0,2.91,.23,4.46,.47,1.56,.24,3.17,.5,4.75,.5,1.75,0,3.26-.31,4.6-.96,.56-.26,.84-.82,.71-1.4Zm-.49,.14c-.01-.06-.03-.11-.05-.16,.02,.05,.04,.11,.05,.16Zm-.09-.25c-.03-.05-.07-.1-.11-.15,.04,.05,.08,.1,.11,.15Zm-.17-.21c-.07-.06-.14-.11-.23-.14,.09,.03,.16,.08,.23,.14Zm-.26-.15c-.08-.03-.16-.04-.25-.04,.01,0,.02,0,.04,0,.08,0,.15,.02,.22,.04Zm-.61,.06c.11-.06,.21-.08,.31-.09-.1,.01-.2,.04-.31,.09-.3,.17-.6,.3-.91,.43,.31-.12,.62-.26,.91-.43Zm-5.05,.98c.2,.01,.41,.02,.61,.02-.2,0-.4,0-.61-.02Zm3.88-.46c-.25,.09-.51,.16-.78,.22,.26-.06,.52-.14,.78-.22Zm-.97,.27c-.32,.07-.65,.12-.98,.15,.33-.03,.66-.08,.98-.15Zm-1.22,.17c-.27,.02-.53,.03-.8,.04,.27,0,.53-.02,.8-.04Zm-1.97,0c-.29-.02-.58-.04-.87-.08,.29,.03,.58,.06,.87,.08Zm.63,1.28c-.11,0-.21-.01-.32-.02,.11,0,.21,.01,.32,.02Zm-1.17-.1c-.07,0-.13-.01-.2-.02,.07,0,.13,.01,.2,.02Zm-1.99-1.46c-.53-.08-1.06-.16-1.6-.23,.54,.07,1.07,.15,1.6,.23Zm-4.91-.5c.31,0,.61,.03,.92,.04-.39-.02-.77-.05-1.16-.04,.08,0,.16,0,.24,0Zm2.71,.2c-.37-.05-.73-.09-1.1-.12,.37,.03,.73,.08,1.1,.12Zm-9.74,.45c1.11-.1,2.22-.26,3.35-.39-1.13,.13-2.24,.29-3.35,.39-.31,.02-.62,.05-.94,.07,.32-.02,.63-.04,.94-.07Zm6.43,.49c-.26,0-.51,.01-.77,.03,.26-.02,.52-.03,.77-.03Zm-1.1,.05c-.28,.02-.55,.05-.83,.08,.28-.03,.56-.06,.83-.08Zm-1.03,.11c-.35,.04-.7,.09-1.05,.15,.35-.05,.7-.1,1.05-.15Zm-7.54-.58c.32,.03,.64,.04,.97,.04-.32,0-.65-.01-.97-.04Zm3.01,1.26c-.08,.01-.17,.02-.25,.03,.08,0,.17-.02,.25-.03Zm-1.06,.11c-.11,0-.22,.02-.33,.02,.11,0,.22-.01,.33-.02Zm-.7-1.33c.26,0,.52-.01,.77-.02-.26,.01-.51,.02-.77,.02Zm-3.36-.55c-.28-.12-.55-.27-.81-.45-.11-.06-.21-.09-.32-.1,.1,.01,.21,.04,.32,.1,.25,.18,.53,.32,.81,.45Zm2,.49c-.28-.03-.55-.07-.81-.12,.27,.05,.54,.1,.81,.12Zm-1.09-.19c-.22-.05-.43-.12-.64-.2,.21,.08,.42,.15,.64,.2Zm-2.09-.86c-.08,0-.16,0-.24,.03,.06-.02,.12-.03,.19-.03,.02,0,.03,0,.05,0Zm-.3,.04c-.09,.03-.17,.08-.24,.14,.07-.06,.15-.11,.24-.14Zm-.3,.2s-.1,.1-.13,.16c.04-.06,.08-.11,.13-.16Zm-.18,.25c-.03,.06-.05,.11-.06,.17,.01-.06,.04-.12,.06-.17Zm-.08,.28c0,.06,0,.12,0,.18,0-.06,0-.12,0-.18Zm.02,.29c.02,.06,.05,.12,.08,.18-.03-.06-.06-.12-.08-.18Zm.13,.27c.06,.08,.15,.16,.25,.23-.11-.06-.19-.14-.25-.23Zm1.22,.63c.1,.04,.2,.06,.3,.1-.1-.03-.2-.06-.3-.1Zm1,.28c.11,.02,.22,.05,.32,.07-.11-.02-.22-.04-.32-.07Zm1.1,.18c.08,0,.15,.02,.22,.03-.08,0-.15-.02-.22-.03Zm1.23,.07c.08,0,.16,0,.24,0-.06,0-.13,0-.19,0-.02,0-.03,0-.05,0Zm4.71-.5c.3-.05,.59-.09,.88-.14-.29,.05-.59,.09-.88,.14Zm-1.2,.19c.1-.01,.19-.03,.29-.05-.1,.02-.19,.03-.29,.05Zm9.75-.35c.3,.05,.6,.09,.9,.14-.3-.05-.6-.09-.9-.14Zm-3.53-.34c.28,0,.56,.01,.85,.03-.28-.02-.57-.03-.85-.03Zm1.17,.05c.26,.02,.52,.05,.78,.08-.26-.03-.52-.05-.78-.08Zm1.04,.1c.34,.04,.68,.09,1.03,.14-.34-.05-.68-.1-1.03-.14Zm3.43,.51c-.11-.02-.22-.03-.33-.05,.11,.02,.22,.03,.33,.05Zm3.22,.29c.09,0,.18,0,.27,0-.02,0-.04,0-.07,0-.07,0-.13,0-.2,0Zm3.61-.51c-.1,.03-.2,.06-.3,.09,.1-.03,.2-.06,.3-.09Zm-1.01,.27c-.11,.02-.21,.05-.32,.06,.11-.02,.21-.04,.32-.06Zm-1.13,.18c-.06,0-.12,.02-.18,.02,.06,0,.12-.02,.18-.02Zm3.12-.84c.11-.05,.2-.12,.27-.2-.07,.08-.15,.14-.27,.2Zm.43-.54c0-.06,.01-.11,.01-.17,0,.06,0,.11-.01,.17Zm-.11,.27c.04-.05,.07-.11,.09-.17-.02,.06-.05,.11-.09,.17Z"
        fill="#b17f5e"
      />
    </g>
    <g
      id="Mouth_A-13-2-1"
      v-if="data.value === 'type-4' && data.position === 'b'"
    >
      <g id="_-14">
        <path
          d="M135.38,221.28s5.73-1.12,14.81-1.82c5.92-.46,9.67,2.01,9.67,2.01,0,0,3.93-2.06,9.25-1.74,6.26,.38,15.81,2.55,15.81,2.55-5.53,6.81-10.62,11.64-24.97,11.7-14.35,.06-19.25-5.91-24.56-12.7Z"
          fill="#f7a6a6"
        />
        <path
          d="M166.15,228.29c-2.9,.24-5.77,.29-8.43,.19-11.13-.44-19.79-3.19-23.39-7.57-.42-.51-.71-1.42-.03-1.73,.68-.32,1.57-.16,1.99,.35,3.06,3.72,16.17,6.85,23.84,6.85s19.96-2.26,24.63-6.79c.49-.48,1.4-.56,2.03-.19,.63,.37,.47,1.31-.02,1.79-4.66,4.53-12.61,6.43-20.62,7.11Z"
          fill="#e26a87"
        />
      </g>
    </g>
    <g
      id="Mouth_A-13-2-2"
      v-if="data.value === 'type-5' && data.position === 'b'"
    >
      <g id="_-15">
        <path
          d="M142.47,221.21s4.01-.86,10.36-1.39c4.14-.35,6.76,1.54,6.76,1.54,0,0,2.75-1.58,6.47-1.33,4.38,.29,11.05,1.95,11.05,1.95-3.87,5.22-7.43,8.92-17.46,8.97s-13.46-4.53-17.18-9.74Z"
          fill="#f7a6a6"
        />
        <path
          d="M164,226.58c-2.03,.19-4.03,.22-5.89,.14-7.79-.33-14.19-2.63-16.71-5.98-.29-.39-.15-.91,.33-1.15,.48-.24,1.1-.12,1.39,.27,2.14,2.85,11.31,4.49,16.67,4.49s13.96-.96,17.22-4.44c.34-.37,.98-.43,1.42-.15,.44,.28,.52,.81,.18,1.17-3.26,3.47-9.01,5.13-14.61,5.64Z"
          fill="#e26a87"
        />
      </g>
    </g>
    <g
      id="Mouth_A-13-2-3"
      v-if="data.value === 'type-6' && data.position === 'b'"
    >
      <g id="_-16">
        <path
          d="M146.47,223.41s3.09-.66,7.98-1.07c3.19-.27,5.21,1.19,5.21,1.19,0,0,2.12-1.22,4.99-1.03,3.37,.23,8.52,1.5,8.52,1.5-2.98,4.02-5.73,6.88-13.46,6.91-7.73,.03-10.37-3.49-13.24-7.5Z"
          fill="#f7a6a6"
        />
        <path
          d="M163.05,227.55c-1.56,.14-3.11,.17-4.54,.11-6-.26-10.93-2.02-12.87-4.61-.23-.3-.11-.7,.25-.89,.37-.19,.85-.1,1.07,.21,1.65,2.2,8.72,3.46,12.85,3.46s10.76-.74,13.27-3.42c.27-.28,.75-.33,1.09-.11,.34,.22,.4,.62,.14,.9-2.51,2.68-6.94,3.95-11.26,4.35Z"
          fill="#e26a87"
        />
      </g>
    </g>
    <g
      id="Mouth_A-13-3-1"
      v-if="data.value === 'type-7' && data.position === 'b'"
    >
      <path
        d="M160,230.58c-17.44,0-25.4-4.24-29-7.79-.49-.48-.5-1.28-.01-1.77,.48-.49,1.28-.5,1.77-.01,3.27,3.23,10.66,7.07,27.25,7.07,18.63,0,25.57-5.41,27.25-7.07,.49-.48,1.28-.48,1.77,.01,.48,.49,.48,1.28-.01,1.77-2.38,2.34-9.96,7.79-29,7.79Z"
        fill="#b17f5e"
      />
    </g>
    <g
      id="Mouth_A-13-3-2"
      v-if="data.value === 'type-8' && data.position === 'b'"
    >
      <path
        d="M160,229.64c-13.3,0-19.55-4.2-22.09-6.71-.45-.45-.46-1.17-.01-1.63,.45-.45,1.17-.46,1.63-.01,2.29,2.26,8,6.05,20.48,6.05,13.3,0,19.04-4.63,20.48-6.05,.45-.45,1.18-.44,1.63,.01s.44,1.18-.01,1.63c-1.6,1.57-7.91,6.71-22.09,6.71Z"
        fill="#b17f5e"
      />
    </g>
    <g
      id="Mouth_A-13-3-3"
      v-if="data.value === 'type-9' && data.position === 'b'"
    >
      <path
        d="M160,230.49c-8.02,0-12.61-2.9-15.05-5.34-.39-.39-.39-1.02,0-1.41s1.02-.39,1.41,0c2.17,2.17,6.3,4.75,13.64,4.75,8.02,0,12.21-3.33,13.64-4.75,.39-.39,1.02-.39,1.41,0s.39,1.02,0,1.41c-1.61,1.61-6.29,5.34-15.05,5.34Z"
        fill="#b17f5e"
      />
    </g>
    <g
      id="Mouth_A-13-4-1"
      v-if="data.value === 'type-10' && data.position === 'b'"
    >
      <g>
        <path
          d="M159.83,223.01c-4.45-1.39-12.49-4.1-23.33-1.99,0,0,.11,7.33,7.95,11.11,6.64,3.21,10.55,3.2,15.38,3.2s8.73,0,15.38-3.2c7.85-3.79,7.95-11.11,7.95-11.11-10.84-2.1-18.88,.61-23.33,1.99Z"
          fill="#fa828b"
        />
        <ellipse
          cx="168.33"
          cy="229.98"
          rx="2.96"
          ry="1.64"
          transform="translate(-25.61 21.14) rotate(-6.68)"
          fill="#ffb6bf"
        />
        <path
          d="M185.73,219.11c-.47-.24-1.04-.06-1.28,.41-.29,.56-.66,1.06-1.11,1.48-1.69,1.59-4.03,1.64-7.28,1.7-1.43,.03-3.06,.06-4.85,.24-4.92,.48-8.27,1.48-10.07,2.02-.56,.17-1.14,.34-1.31,.35-.17-.01-.75-.18-1.31-.35-1.8-.54-5.16-1.54-10.07-2.02-1.79-.18-3.42-.21-4.85-.24-3.24-.07-5.59-.12-7.28-1.7-.45-.42-.83-.92-1.11-1.48-.24-.47-.81-.65-1.28-.41-.47,.24-.65,.81-.41,1.28,.39,.75,.9,1.43,1.5,2,2.22,2.08,5.01,2.14,8.54,2.22,1.4,.03,2.99,.06,4.71,.23,4.73,.46,7.85,1.4,9.71,1.95,.93,.28,1.45,.43,1.86,.43s.92-.15,1.86-.43c1.86-.56,4.98-1.49,9.71-1.95,1.72-.17,3.31-.2,4.71-.23,3.53-.07,6.31-.13,8.54-2.22,.61-.57,1.12-1.24,1.5-2,.24-.47,.06-1.04-.41-1.28Z"
          fill="#b74656"
        />
      </g>
    </g>
    <g
      id="Mouth_A-13-4-2"
      v-if="data.value === 'type-11' && data.position === 'b'"
    >
      <g>
        <path
          d="M159.4,224.4c-3.38-1.16-9.49-3.42-17.71-1.66,0,0,.08,6.12,6.04,9.28,5.04,2.68,8.01,2.68,11.68,2.68s6.63,0,11.68-2.68c5.96-3.16,6.04-9.28,6.04-9.28-8.23-1.75-14.34,.51-17.71,1.66Z"
          fill="#fa828b"
        />
        <ellipse
          cx="165.85"
          cy="230.21"
          rx="2.25"
          ry="1.37"
          transform="translate(-30.7 25.58) rotate(-8.08)"
          fill="#ffb6bf"
        />
        <path
          d="M179.05,221.17c-.38-.18-.82-.01-1,.36-.22,.47-.51,.89-.85,1.25-1.27,1.31-2.95,1.35-5.48,1.41-1.09,.03-2.33,.05-3.69,.2-3.74,.4-6.29,1.24-7.67,1.69-.39,.13-.83,.27-.97,.29-.14-.02-.58-.16-.97-.29-1.37-.45-3.92-1.29-7.67-1.69-1.37-.15-2.6-.18-3.69-.2-2.53-.06-4.21-.1-5.48-1.41-.35-.36-.63-.78-.85-1.25-.18-.38-.62-.54-1-.36-.38,.18-.54,.62-.36,1,.29,.62,.67,1.18,1.13,1.66,1.7,1.75,3.83,1.8,6.52,1.87,1.06,.02,2.26,.05,3.57,.19,3.58,.39,5.95,1.16,7.36,1.63,.72,.24,1.11,.37,1.44,.37s.72-.13,1.44-.37c1.41-.46,3.77-1.24,7.36-1.63,1.3-.14,2.51-.17,3.57-.19,2.7-.06,4.82-.11,6.52-1.87,.46-.47,.84-1.03,1.13-1.66,.18-.38,.01-.82-.36-1Z"
          fill="#b74656"
        />
      </g>
    </g>
    <g
      id="Mouth_A-13-4-3"
      v-if="data.value === 'type-12' && data.position === 'b'"
    >
      <g>
        <path
          d="M159.8,225.13c-2.54-.87-7.14-2.57-13.33-1.25,0,0,.06,4.6,4.55,6.98,3.8,2.01,6.03,2.01,8.79,2.01s4.99,0,8.79-2.01c4.48-2.38,4.55-6.98,4.55-6.98-6.19-1.32-10.79,.38-13.33,1.25Z"
          fill="#fa828b"
        />
        <ellipse
          cx="164.2"
          cy="229.5"
          rx="1.69"
          ry="1.03"
          transform="translate(-30.61 25.34) rotate(-8.08)"
          fill="#ffb6bf"
        />
        <path
          d="M174.67,222.53c-.37-.18-.82-.01-1,.36-.16,.34-.36,.64-.61,.89-.9,.93-2.13,.96-4,1-.82,.02-1.76,.04-2.79,.15-2.84,.31-4.77,.94-5.81,1.28-.26,.09-.55,.18-.67,.2-.11-.02-.41-.12-.67-.2-1.04-.34-2.97-.98-5.81-1.28-1.04-.11-1.97-.13-2.79-.15-1.86-.04-3.09-.07-4-1.01-.24-.25-.45-.55-.61-.89-.18-.38-.62-.54-1-.36-.38,.18-.54,.62-.36,1,.23,.49,.53,.93,.89,1.3,1.33,1.37,3.05,1.41,5.04,1.46,.79,.02,1.7,.04,2.67,.14,2.68,.29,4.44,.87,5.5,1.22,.56,.18,.87,.28,1.14,.28s.58-.1,1.14-.28c1.06-.35,2.82-.93,5.5-1.22,.97-.1,1.87-.13,2.67-.14,1.99-.05,3.71-.09,5.04-1.46,.36-.37,.66-.81,.89-1.3,.18-.38,.01-.82-.36-1Z"
          fill="#b74656"
        />
      </g>
    </g>
    <g
      id="Mouth_A-13-5-1"
      v-if="data.value === 'type-13' && data.position === 'b'"
    >
      <g>
        <g id="_-17">
          <path
            d="M182.06,222.3c-.75-.29-4.7-1.62-16.29-2.64-.22-.02-.43-.04-.65-.06-1.73-.09-3.44-.13-5.1-.13-.08,0-.15,0-.23,0-.08,0-.15,0-.23,0-1.66,0-3.37,.04-5.1,.13-.22,.02-.44,.04-.65,.06-11.59,1.01-15.55,2.35-16.29,2.64-.1,.04-.14,.06-.14,.06,1.53,6.87,9.54,12.7,22.41,12.32,12.87,.39,20.88-5.44,22.41-12.32,0,0-.05-.02-.14-.06Z"
            fill="#fbb2be"
          />
        </g>
        <path
          d="M159.79,226.64c11.06,0,20.26,.2,22.23-2.63,.06-.21,.13-1.44,.18-1.65,0,0-.05-.02-.14-.06-.75-.29-4.7-1.62-16.29-2.64-.22-.02-.43-.04-.65-.06-1.73-.09-3.44-.13-5.1-.13-.08,0-.15,0-.23,0-.08,0-.15,0-.23,0-1.66,0-3.37,.04-5.1,.13-.22,.02-.44,.04-.65,.06-11.59,1.01-15.55,2.35-16.29,2.64-.1,.04-.14,.06-.14,.06,.05,.21,.12,1.44,.18,1.65,1.97,2.82,11.17,2.63,22.23,2.63Z"
          fill="#fffdfc"
        />
        <path
          d="M160.86,235.49c-.36,0-.73,0-1.1-.02-13.66,.4-21.61-6.94-23.17-13.94-.1-.43,.17-.85,.6-.95,.43-.1,.86,.17,.96,.59l.02,.06c1.74-.53,6.07-1.54,15.57-2.37l.66-.06c1.68-.09,3.43-.13,5.17-.13h.45c1.75,0,3.49,.04,5.14,.13l.68,.06c9.51,.83,13.84,1.85,15.57,2.38l.03-.09c.11-.42,.54-.67,.96-.57,.42,.1,.68,.53,.59,.95-1.52,6.81-9.07,13.96-22.12,13.96Zm-1.1-1.62c11.31,.35,18.88-5.1,21.18-11.1-1.53-.47-5.73-1.48-15.24-2.31l-.65-.06c-1.6-.09-3.3-.13-5.03-.13h-.45c-1.73,.03-3.43,.04-5.06,.13l-.63,.06c-9.49,.83-13.7,1.84-15.24,2.31,2.29,6,9.86,11.44,21.13,11.11Z"
          fill="#b17f5e"
        />
      </g>
    </g>
    <g
      id="Mouth_A-13-5-2"
      v-if="data.value === 'type-14' && data.position === 'b'"
    >
      <g>
        <g id="_-18">
          <path
            d="M176.36,224.18c-.57-.23-3.61-1.28-12.5-2.08-.17-.02-.33-.03-.5-.05-1.33-.07-2.64-.1-3.91-.1-.06,0-.12,0-.17,0-.06,0-.12,0-.17,0-1.28,0-2.58,.03-3.91,.1-.17,.01-.33,.03-.5,.05-8.89,.8-11.93,1.85-12.5,2.08-.07,.03-.11,.05-.11,.05,1.18,5.42,7.32,10.03,17.2,9.72,9.88,.31,16.02-4.3,17.2-9.72,0,0-.04-.02-.11-.05Z"
            fill="#fbb2be"
          />
        </g>
        <path
          d="M159.27,227.6c8.49,0,15.55,.15,17.06-2.07,.05-.17,.1-1.13,.14-1.3,0,0-.04-.02-.11-.05-.57-.23-3.61-1.28-12.5-2.08-.17-.02-.33-.03-.5-.05-1.33-.07-2.64-.1-3.91-.1-.06,0-.12,0-.17,0-.06,0-.12,0-.17,0-1.28,0-2.58,.03-3.91,.1-.17,.01-.33,.03-.5,.05-8.89,.8-11.93,1.85-12.5,2.08-.07,.03-.11,.05-.11,.05,.04,.17,.09,1.14,.14,1.3,1.51,2.23,8.57,2.07,17.06,2.07Z"
          fill="#fffdfc"
        />
        <path
          d="M176.78,222.48c-.36-.15-.77-.02-.98,.31-.05,.08-.11,.17-.15,.25-.54-.15-1.3-.32-2.37-.53-1.73-.33-4.76-.8-9.34-1.21l-.53-.05c-1.24-.07-2.72-.15-4.05-.11h0s-.28,0-.29,0c-1.35,0-2.67,.04-3.95,.11l-.5,.05c-6.82,.61-10.19,1.39-11.72,1.87-.02-.05-.03-.1-.04-.16-.12-.42-.54-.67-.96-.56-.42,.1-.68,.52-.59,.95,1.28,5.88,7.88,11.66,17.95,11.35,.26,0,.53,.01,.79,.01,9.69,0,15.98-5.64,17.22-11.36,.08-.38-.12-.76-.48-.91Zm-17.53,10.66c-8.3,.26-13.96-3.84-15.88-8.46,1.42-.44,4.64-1.19,11.38-1.8l.47-.04c1.2-.07,2.77-.1,4.11-.1h.11c1.34,.01,2.63,.04,3.84,.1l.5,.05c6.46,.58,10.12,1.32,11.43,1.69-1.87,4.66-7.56,8.83-15.97,8.56Z"
          fill="#b17f5e"
        />
      </g>
    </g>
    <g
      id="Mouth_A-13-5-3"
      v-if="data.value === 'type-15' && data.position === 'b'"
    >
      <g>
        <g id="_-19">
          <path
            d="M172.6,224.68c-.43-.17-2.72-.97-9.43-1.57-.13-.01-.25-.02-.38-.03-1-.06-1.99-.08-2.95-.08-.04,0-.09,0-.13,0-.04,0-.09,0-.13,0-.96,0-1.95,.02-2.95,.08-.13,.01-.25,.02-.38,.03-6.71,.6-8.99,1.4-9.43,1.57-.06,.02-.08,.03-.08,.03,.89,4.09,5.52,7.56,12.97,7.33,7.45,.23,12.08-3.24,12.97-7.33,0,0-.03-.01-.08-.03Z"
            fill="#fbb2be"
          />
        </g>
        <path
          d="M159.71,226.25c6.4,0,11.72,.12,12.86-1.56,.03-.13,.08,.14,.1,.02,0,0-.03-.01-.08-.03-.43-.17-2.72-.97-9.43-1.57-.13-.01-.25-.02-.38-.03-1-.06-1.99-.08-2.95-.08-.04,0-.09,0-.13,0-.04,0-.09,0-.13,0-.96,0-1.95,.02-2.95,.08-.13,.01-.25,.02-.38,.03-6.71,.6-8.99,1.4-9.43,1.57-.06,.02-.08,.03-.08,.03,.03,.13,.07-.14,.1-.02,1.14,1.68,6.46,1.56,12.86,1.56Z"
          fill="#fffdfc"
        />
        <path
          d="M172.96,222.96c-.37-.14-.79,.02-.98,.37-.07,.12-.13,.24-.19,.35-1.24-.43-3.69-.92-8.55-1.36l-.4-.04c-.94-.05-2.11-.11-3.13-.08h0s-.04,0-.06,0h0c-.99,0-2.14,.02-3.09,.08l-.38,.03c-.07,0-5.83,.56-8.52,1.37-.07-.12-.15-.26-.25-.41-.21-.32-.62-.45-.98-.3-.35,.15-.55,.53-.47,.91,.98,4.52,5.81,8.97,13.15,8.97,.19,0,.38,0,.57,0,7.71,.23,12.77-4.33,13.77-8.96,.08-.39-.13-.78-.5-.92Zm-13.27,8.28c-5.89,.18-10-2.69-11.59-6.03,1.17-.32,3.87-.91,8.22-1.3l.35-.03c.93-.05,1.91-.06,2.91-.08h.26c1,0,1.98,.02,2.88,.08l.38,.03c4.75,.43,7.26,.98,8.24,1.27-1.58,3.36-5.71,6.25-11.65,6.07Z"
          fill="#b17f5e"
        />
      </g>
    </g>
    <g
      id="Mouth_A-13-6-1"
      v-if="data.value === 'type-16' && data.position === 'b'"
    >
      <g>
        <g>
          <g id="_-20">
            <path
              d="M182.06,222.3c-.75-.29-4.7-1.62-16.29-2.64-.22-.02-.43-.04-.65-.06-1.73-.09-3.44-.13-5.1-.13-.08,0-.15,0-.23,0-.08,0-.15,0-.23,0-1.66,0-3.37,.04-5.1,.13-.22,.02-.44,.04-.65,.06-11.59,1.01-15.55,2.35-16.29,2.64-.1,.04-.14,.06-.14,.06,1.53,6.87,9.54,12.7,22.41,12.32,12.87,.39,20.88-5.44,22.41-12.32,0,0-.05-.02-.14-.06Z"
              fill="#fbb2be"
            />
          </g>
          <path
            d="M161.03,234.88c11.05,.38,17.73-6.11,20.18-10.78,.06-.21,.95-1.52,.99-1.74,0,0-.05-.02-.14-.06-.75-.29-4.7-1.62-16.29-2.64-.22-.02-.43-.04-.65-.06-1.73-.09-3.44-.13-5.1-.13-.08,0-.15,0-.23,0-.08,0-.15,0-.23,0-1.66,0-3.37,.04-5.1,.13-.22,.02-.44,.04-.65,.06-11.59,1.01-15.55,2.35-16.29,2.64-.1,.04-.14,.06-.14,.06,.05,.21,.74,1.45,.8,1.66,1.97,2.82,4.97,10.24,22.85,10.85Z"
            fill="#fffdfc"
          />
        </g>
        <path
          d="M163.6,225.95c-.53-.13-2.66-.21-3.35-.23-.02-.59-.09-2.79-.23-3.38-.04-.16-.31-.16-.35,0-.13,.54-.2,2.68-.23,3.38-.58,.02-2.77,.09-3.35,.23-.08,.02-.14,.09-.14,.18s.06,.16,.14,.18c.58,.14,2.77,.21,3.35,.23,.03,.71,.1,2.85,.23,3.39,.02,.08,.09,.14,.17,.14s.15-.06,.17-.14c.13-.54,.2-2.68,.23-3.38,.58-.02,2.77-.09,3.35-.23,.08-.02,.14-.09,.14-.18s-.06-.16-.14-.18Z"
          fill="#838383"
        />
        <g>
          <path
            d="M154.94,226.03c-.49-.1-2.51-.09-3.14-.09-.04-.53-.15-2.6-.29-3.12-.04-.14-.29-.13-.31,.01-.1,.49-.13,2.51-.12,3.14-.53,.04-1.6,.15-2.12,.29-.07,.02-.12,.09-.12,.16s.06,.14,.13,.15c.53,.1,1.61,.12,2.14,.12,.05,.63,.16,2.64,.29,3.12,.02,.07,.09,.12,.16,.12s.14-.06,.15-.13c.1-.49,.13-2.51,.12-3.14,.53-.04,2.6-.18,3.12-.33,.07-.02,.12-.09,.12-.16s-.06-.14-.13-.15Z"
            fill="#838383"
          />
          <path
            d="M147.82,226.36c-.49-.07-2.51,.03-3.14,.06-.07-.52-.22-1.59-.39-2.1-.05-.14-.29-.12-.31,.03-.07,.49-.05,1.51-.02,2.14-.52,.07-1.59,.22-2.1,.39-.07,.02-.12,.09-.11,.17s.06,.13,.14,.15c.54,.08,1.61,.05,2.14,.02,.08,.63,.24,1.63,.39,2.1,.02,.07,.09,.12,.17,.11s.13-.06,.15-.14c.07-.49,.05-1.51,.02-2.14,.52-.07,2.59-.31,3.1-.48,.07-.02,.12-.09,.11-.17s-.06-.13-.14-.15Z"
            fill="#838383"
          />
        </g>
        <g>
          <path
            d="M164.87,226.03c.49-.1,2.51-.09,3.14-.09,.04-.53,.15-2.6,.29-3.12,.04-.14,.29-.13,.31,.01,.1,.49,.13,2.51,.12,3.14,.53,.04,1.6,.15,2.12,.29,.07,.02,.12,.09,.12,.16s-.06,.14-.13,.15c-.53,.1-1.61,.12-2.14,.12-.05,.63-.16,2.64-.29,3.12-.02,.07-.09,.12-.16,.12s-.14-.06-.15-.13c-.1-.49-.13-2.51-.12-3.14-.53-.04-2.6-.18-3.12-.33-.07-.02-.12-.09-.12-.16s.06-.14,.13-.15Z"
            fill="#838383"
          />
          <path
            d="M172,226.36c.49-.07,2.51,.03,3.14,.06,.07-.52,.22-1.59,.39-2.1,.05-.14,.29-.12,.31,.03,.07,.49,.05,1.51,.02,2.14,.52,.07,1.59,.22,2.1,.39,.07,.02,.12,.09,.11,.17s-.06,.13-.14,.15c-.54,.08-1.61,.05-2.14,.02-.08,.63-.24,1.63-.39,2.1-.02,.07-.09,.12-.17,.11s-.13-.06-.15-.14c-.07-.49-.05-1.51-.02-2.14-.52-.07-2.59-.31-3.1-.48-.07-.02-.12-.09-.11-.17s.06-.13,.14-.15Z"
            fill="#838383"
          />
        </g>
        <path
          d="M160.86,235.49c-.36,0-.73,0-1.1-.02-13.66,.4-21.61-6.94-23.17-13.94-.1-.43,.17-.85,.6-.95,.43-.1,.86,.17,.96,.59l.02,.06c1.74-.53,6.07-1.54,15.57-2.37l.66-.06c1.68-.09,3.43-.13,5.17-.13h.45c1.75,0,3.49,.04,5.14,.13l.68,.06c9.51,.83,13.84,1.85,15.57,2.38l.03-.09c.11-.42,.54-.67,.96-.57,.42,.1,.68,.53,.59,.95-1.52,6.81-9.07,13.96-22.12,13.96Zm-1.1-1.62c11.31,.35,18.88-5.1,21.18-11.1-1.53-.47-5.73-1.48-15.24-2.31l-.65-.06c-1.6-.09-3.3-.13-5.03-.13h-.45c-1.73,.03-3.43,.04-5.06,.13l-.63,.06c-9.49,.83-13.7,1.84-15.24,2.31,2.29,6,9.86,11.44,21.13,11.11Z"
          fill="#b17f5e"
        />
      </g>
    </g>
    <g
      id="Mouth_A-13-6-2"
      v-if="data.value === 'type-17' && data.position === 'b'"
    >
      <g>
        <g>
          <g id="_-21">
            <path
              d="M176.36,224.18c-.57-.23-3.61-1.28-12.5-2.08-.17-.02-.33-.03-.5-.05-1.33-.07-2.64-.1-3.91-.1-.06,0-.12,0-.17,0-.06,0-.12,0-.17,0-1.28,0-2.58,.03-3.91,.1-.17,.01-.33,.03-.5,.05-8.89,.8-11.93,1.85-12.5,2.08-.07,.03-.11,.05-.11,.05,1.18,5.42,7.32,10.03,17.2,9.72,9.88,.31,16.02-4.3,17.2-9.72,0,0-.04-.02-.11-.05Z"
              fill="#fbb2be"
            />
          </g>
          <path
            d="M159.27,233.95c11.01-.01,14.91-6.16,16.42-8.39,.05-.17,.74-1.16,.78-1.33,0,0-.04-.02-.11-.05-.57-.23-3.61-1.28-12.5-2.08-.17-.02-.33-.03-.5-.05-1.33-.07-2.64-.1-3.91-.1-.06,0-.12,0-.17,0-.06,0-.12,0-.17,0-1.28,0-2.58,.03-3.91,.1-.17,.01-.33,.03-.5,.05-8.89,.8-11.93,1.85-12.5,2.08-.07,.03-.11,.05-.11,.05,.04,.17,.7,1.24,.74,1.41,1.51,2.23,5.6,8.33,16.46,8.32Z"
            fill="#fffdfc"
          />
        </g>
        <path
          d="M162.5,227.61c-.45-.11-2.23-.17-2.81-.2-.02-.49-.08-2.35-.19-2.84-.03-.14-.26-.14-.29,0-.11,.45-.17,2.25-.19,2.84-.49,.02-2.32,.08-2.81,.2-.07,.02-.12,.08-.12,.15s.05,.13,.12,.15c.49,.12,2.32,.18,2.81,.2,.02,.59,.09,2.39,.19,2.84,.02,.07,.08,.12,.15,.12s.13-.05,.15-.12c.11-.45,.17-2.25,.19-2.84,.49-.02,2.32-.08,2.81-.2,.07-.02,.11-.08,.11-.15s-.05-.13-.11-.15Z"
          fill="#838383"
        />
        <g>
          <path
            d="M155.23,227.67c-.41-.08-2.1-.07-2.63-.07-.03-.44-.12-2.18-.24-2.62-.03-.12-.24-.11-.26,.01-.08,.41-.11,2.1-.1,2.63-.44,.03-1.34,.12-1.78,.24-.06,.02-.1,.07-.1,.14s.05,.12,.11,.13c.45,.09,1.35,.1,1.79,.1,.04,.53,.13,2.22,.24,2.62,.02,.06,.07,.1,.14,.1s.12-.05,.13-.11c.08-.41,.11-2.1,.1-2.63,.44-.03,2.18-.15,2.62-.28,.06-.02,.1-.07,.1-.14s-.05-.12-.11-.13Z"
            fill="#838383"
          />
          <path
            d="M149.25,227.96c-.41-.06-2.11,.03-2.63,.05-.05-.44-.19-1.33-.33-1.77-.04-.12-.24-.1-.26,.02-.06,.41-.05,1.27-.02,1.8-.44,.05-1.33,.19-1.77,.33-.06,.02-.1,.08-.09,.14s.05,.11,.12,.12c.45,.07,1.35,.04,1.8,.02,.06,.53,.2,1.37,.33,1.77,.02,.06,.08,.1,.14,.09s.11-.05,.12-.11c.06-.41,.05-1.27,.02-1.8,.44-.05,2.17-.26,2.6-.4,.06-.02,.1-.08,.09-.14s-.05-.11-.11-.12Z"
            fill="#838383"
          />
        </g>
        <g>
          <path
            d="M163.57,227.67c.41-.08,2.1-.07,2.63-.07,.03-.44,.12-2.18,.24-2.62,.03-.12,.24-.11,.26,.01,.08,.41,.11,2.1,.1,2.63,.44,.03,1.34,.12,1.78,.24,.06,.02,.1,.07,.1,.14s-.05,.12-.11,.13c-.45,.09-1.35,.1-1.79,.1-.04,.53-.13,2.22-.24,2.62-.02,.06-.07,.1-.14,.1s-.12-.05-.13-.11c-.08-.41-.11-2.1-.1-2.63-.44-.03-2.18-.15-2.62-.28-.06-.02-.1-.07-.1-.14s.05-.12,.11-.13Z"
            fill="#838383"
          />
          <path
            d="M169.55,227.96c.41-.06,2.11,.03,2.63,.05,.05-.44,.19-1.33,.33-1.77,.04-.12,.24-.1,.26,.02,.06,.41,.05,1.27,.02,1.8,.44,.05,1.33,.19,1.77,.33,.06,.02,.1,.08,.09,.14s-.05,.11-.12,.12c-.45,.07-1.35,.04-1.8,.02-.06,.53-.2,1.37-.33,1.77-.02,.06-.08,.1-.14,.09s-.11-.05-.12-.11c-.06-.41-.05-1.27-.02-1.8-.44-.05-2.17-.26-2.6-.4-.06-.02-.1-.08-.09-.14s.05-.11,.11-.12Z"
            fill="#838383"
          />
        </g>
        <path
          d="M176.78,222.48c-.36-.15-.77-.02-.98,.31-.05,.08-.11,.17-.15,.25-.54-.15-1.3-.32-2.37-.53-1.73-.33-4.76-.8-9.34-1.21l-.53-.05c-1.24-.07-2.72-.15-4.05-.11h0s-.28,0-.29,0c-1.35,0-2.67,.04-3.95,.11l-.5,.05c-6.82,.61-10.19,1.39-11.72,1.87-.02-.05-.03-.1-.04-.16-.12-.42-.54-.67-.96-.56-.42,.1-.68,.52-.59,.95,1.28,5.88,7.88,11.66,17.95,11.35,.26,0,.53,.01,.79,.01,9.69,0,15.98-5.64,17.22-11.36,.08-.38-.12-.76-.48-.91Zm-17.53,10.66c-8.3,.26-13.96-3.84-15.88-8.46,1.42-.44,4.64-1.19,11.38-1.8l.47-.04c1.2-.07,2.77-.1,4.11-.1h.11c1.34,.01,2.63,.04,3.84,.1l.5,.05c6.46,.58,10.12,1.32,11.43,1.69-1.87,4.66-7.56,8.83-15.97,8.56Z"
          fill="#b17f5e"
        />
      </g>
    </g>
    <g
      id="Mouth_A-13-6-3"
      v-if="data.value === 'type-18' && data.position === 'b'"
    >
      <g>
        <g>
          <g id="_-22">
            <path
              d="M172.6,224.68c-.43-.17-2.72-.97-9.43-1.57-.13-.01-.25-.02-.38-.03-1-.06-1.99-.08-2.95-.08-.04,0-.09,0-.13,0-.04,0-.09,0-.13,0-.96,0-1.95,.02-2.95,.08-.13,.01-.25,.02-.38,.03-6.71,.6-8.99,1.4-9.43,1.57-.06,.02-.08,.03-.08,.03,.89,4.09,5.52,7.56,12.97,7.33,7.45,.23,12.08-3.24,12.97-7.33,0,0-.03-.01-.08-.03Z"
              fill="#fbb2be"
            />
          </g>
          <path
            d="M160.36,232.05c8.08,0,11.07-5.68,12.21-7.36,.03-.13,.08,.14,.1,.02,0,0-.03-.01-.08-.03-.43-.17-2.72-.97-9.43-1.57-.13-.01-.25-.02-.38-.03-1-.06-1.99-.08-2.95-.08-.04,0-.09,0-.13,0-.04,0-.09,0-.13,0-.96,0-1.95,.02-2.95,.08-.13,.01-.25,.02-.38,.03-6.71,.6-8.99,1.4-9.43,1.57-.06,.02-.08,.03-.08,.03,.03,.13,.07-.14,.1-.02,1.14,1.68,2.73,7.35,13.51,7.36Z"
            fill="#fffdfc"
          />
        </g>
        <g>
          <path
            d="M162.38,227.17c-.38-.09-1.92-.15-2.42-.17-.02-.43-.07-2.02-.17-2.44-.03-.12-.22-.12-.25,0-.09,.39-.15,1.93-.17,2.44-.42,.02-2,.07-2.42,.17-.06,.01-.1,.07-.1,.13s.04,.11,.1,.13c.42,.1,2,.15,2.42,.17,.02,.51,.07,2.05,.17,2.44,.01,.06,.07,.1,.12,.1s.11-.04,.12-.1c.09-.39,.15-1.93,.17-2.44,.42-.02,2-.07,2.42-.17,.06-.01,.1-.07,.1-.13s-.04-.11-.1-.13Z"
            fill="#838383"
          />
          <g>
            <path
              d="M156.13,227.22c-.35-.07-1.81-.06-2.26-.06-.03-.38-.1-1.87-.21-2.25-.03-.1-.21-.1-.23,0-.07,.35-.09,1.81-.09,2.26-.38,.03-1.15,.1-1.53,.21-.05,.01-.09,.06-.09,.12s.04,.1,.09,.11c.38,.08,1.16,.09,1.54,.09,.03,.45,.11,1.91,.21,2.25,.01,.05,.06,.09,.12,.08s.1-.04,.11-.09c.07-.35,.09-1.81,.09-2.26,.38-.03,1.87-.13,2.25-.24,.05-.01,.09-.06,.08-.12s-.04-.1-.09-.11Z"
              fill="#838383"
            />
            <path
              d="M148.77,228.04c.38-.05,1.87-.22,2.24-.34,.05-.02,.08-.07,.08-.12s-.05-.1-.1-.11c-.35-.05-1.81,.02-2.26,.05-.05-.38-.16-1.15-.28-1.52-.03-.1-.21-.09-.23,.02-.05,.35-.04,1.09-.02,1.54l.04,.52,.52-.05Z"
              fill="#838383"
            />
          </g>
          <g>
            <path
              d="M163.29,227.22c.35-.07,1.81-.06,2.26-.06,.03-.38,.1-1.87,.21-2.25,.03-.1,.21-.1,.23,0,.07,.35,.09,1.81,.09,2.26,.38,.03,1.15,.1,1.53,.21,.05,.01,.09,.06,.09,.12s-.04,.1-.09,.11c-.38,.08-1.16,.09-1.54,.09-.03,.45-.11,1.91-.21,2.25-.01,.05-.06,.09-.12,.08s-.1-.04-.11-.09c-.07-.35-.09-1.81-.09-2.26-.38-.03-1.87-.13-2.25-.24-.05-.01-.09-.06-.08-.12s.04-.1,.09-.11Z"
              fill="#838383"
            />
            <path
              d="M171.22,227.56c.02-.45,.04-1.19-.02-1.54-.02-.11-.19-.12-.23-.02-.12,.37-.23,1.14-.28,1.52-.45-.02-1.91-.1-2.26-.05-.05,0-.09,.05-.1,.11s.03,.1,.08,.12c.37,.12,1.86,.3,2.24,.34l.52,.05,.04-.52Z"
              fill="#838383"
            />
          </g>
        </g>
        <path
          d="M172.96,222.96c-.37-.14-.79,.02-.98,.37-.07,.12-.13,.24-.19,.35-1.24-.43-3.69-.92-8.55-1.36l-.4-.04c-.94-.05-2.11-.11-3.13-.08h0s-.04,0-.06,0h0c-.99,0-2.14,.02-3.09,.08l-.38,.03c-.07,0-5.83,.56-8.52,1.37-.07-.12-.15-.26-.25-.41-.21-.32-.62-.45-.98-.3-.35,.15-.55,.53-.47,.91,.98,4.52,5.81,8.97,13.15,8.97,.19,0,.38,0,.57,0,7.71,.23,12.77-4.33,13.77-8.96,.08-.39-.13-.78-.5-.92Zm-13.27,8.28c-5.89,.18-10-2.69-11.59-6.03,1.17-.32,3.87-.91,8.22-1.3l.35-.03c.93-.05,1.91-.06,2.91-.08h.26c1,0,1.98,.02,2.88,.08l.38,.03c4.75,.43,7.26,.98,8.24,1.27-1.58,3.36-5.71,6.25-11.65,6.07Z"
          fill="#b17f5e"
        />
      </g>
    </g>
    <g
      id="Mouth_A-13-7-1"
      v-if="data.value === 'type-19' && data.position === 'b'"
    >
      <g>
        <path
          d="M187.86,224.28s-.02-.09-.03-.13c-.05-.21-.11-.41-.2-.62v-.03c-.1-.2-.21-.41-.34-.61-.02-.03-.05-.07-.07-.1-.13-.19-.27-.38-.43-.57h0s-.02-.04-.04-.06c-.02-.02-.03-.03-.05-.05-.02-.02-.05-.05-.07-.07-.07-.07-.13-.14-.2-.22l-.02-.02c-.21-.23-.4-.47-.59-.71-.51-.48-1.02-.82-1.09-.87-.15-.11-.32-.23-.51-.34-2.35-1.55-7-4.85-14.32-5.55-.23-.02-.46-.05-.7-.07-4.53-.36-6.71,.99-8.48,1.89-.38,.19-.78,.29-1.18,.31-.05,0-.1,.02-.15,.02-.05,0-.1-.01-.15-.02-.4-.02-.8-.12-1.18-.31-1.77-.9-3.95-2.25-8.48-1.89-.24,.02-.47,.05-.7,.07-7.32,.7-11.96,3.99-14.32,5.55-.18,.12-.35,.24-.51,.34-.07,.05-.58,.39-1.09,.87-.19,.24-.38,.48-.59,.71l-.02,.02c-.07,.07-.14,.14-.2,.22-.02,.02-.05,.05-.07,.07-.02,.02-.03,.03-.05,.05-.02,.02-.02,.03-.04,.05h0c-.16,.2-.3,.39-.43,.58-.02,.03-.05,.07-.07,.1-.12,.2-.23,.4-.32,.61v.03c-.1,.2-.16,.41-.21,.62,0,.04-.02,.09-.03,.13-.04,.21-.07,.42-.07,.63,0,1.92,1.45,4.02,4.5,5.83,1.41,.84,3.15,1.61,5.25,2.28,.35,.11,.71,.22,1.08,.33,.74,.21,1.52,.41,2.34,.59,.41,.09,.83,.18,1.26,.27,.86,.17,1.76,.32,2.7,.46s1.92,.26,2.94,.36c1.53,.15,3.16,.27,4.88,.33,1.15,.04,2.34,.07,3.57,.07h0c1.23,0,2.42-.02,3.57-.07,1.72-.07,3.35-.18,4.88-.33,1.02-.1,2-.22,2.94-.36,1.41-.21,2.73-.45,3.96-.73,.82-.18,1.6-.38,2.34-.59,.37-.11,.73-.21,1.08-.33,1.05-.34,2.01-.7,2.89-1.08,.87-.38,1.66-.79,2.37-1.2,3.05-1.81,4.5-3.91,4.5-5.83,0-.21-.03-.42-.07-.63Z"
          fill="#ebb291"
        />
        <path
          id="_-23"
          d="M184.14,225.82c-7.81,3.47-16.52-.14-24.49-.1-8.03-.1-16.9,3.75-24.67,.12-1.67-.92-.25-3.27,1.47-2.4,3.05,2.01,7.33,1.75,11.02,1.47,3.97-.34,7.98-1.05,12.16-1.07,4.2-.06,8.23,.8,12.17,1.18,3.8,.39,7.76,.29,11.1-1.48,1.65-.83,2.96,1.52,1.23,2.28h0Z"
          fill="#b17f5e"
        />
      </g>
    </g>
    <g
      id="Mouth_A-13-7-2"
      v-if="data.value === 'type-20' && data.position === 'b'"
    >
      <g>
        <path
          d="M184,223.89s-.02-.09-.03-.14c-.05-.22-.12-.44-.21-.65v-.03c-.11-.22-.23-.43-.36-.64-.01-.02-.03-.04-.04-.07-.14-.22-.31-.44-.49-.65h0s-.02-.05-.04-.06c-.02-.02-.04-.04-.05-.06-.02-.03-.05-.05-.07-.08-.07-.08-.14-.15-.22-.23l-.02-.03c-.61-.65-1.19-1.27-1.81-1.8-9.34-7.94-16.46-4.81-19.83-3.13-.4,.2-.83,.3-1.27,.33-.06,0-.11,.02-.17,.02-.06,0-.11-.02-.17-.02-.43-.03-.86-.13-1.27-.33-3.36-1.68-10.48-4.82-19.83,3.13-.62,.52-1.2,1.15-1.81,1.8l-.02,.03c-.08,.08-.15,.15-.22,.23-.02,.03-.05,.05-.07,.08-.02,.02-.04,.04-.05,.06-.02,.02-.02,.03-.04,.05h0c-.18,.23-.35,.44-.49,.66-.01,.02-.03,.04-.04,.07-.13,.21-.25,.43-.35,.64v.03c-.11,.22-.17,.43-.23,.65-.01,.05-.02,.09-.03,.14-.04,.22-.07,.44-.07,.67,0,5.01,12.75,11.15,24.69,11.15h0c11.94,0,24.69-6.14,24.69-11.15,0-.22-.03-.45-.07-.67Z"
          fill="#ebb291"
        />
        <g>
          <path
            d="M138.42,224.37c-.14,.35-.02,.6,.31,.78-.16-.21-.25-.48-.31-.78Z"
            fill="#e2b291"
          />
          <path
            d="M151.95,224.93c2.29-.14,4.72-.26,7.17-.28-.32,0-.64,0-.96,0-2.23,0-4.31,.12-6.21,.29Z"
            fill="#e2b291"
          />
          <path
            d="M166.3,224.93c7.19,.64,11.91,1.97,13.22,.22-1.41,.76-6.74,.18-13.22-.22Z"
            fill="#e2b291"
          />
          <path
            d="M138.73,225.15c1.31,1.75,6.03,.41,13.22-.22-6.48,.4-11.8,.99-13.22,.22Z"
            fill="#e2b291"
          />
          <path
            d="M179.52,225.15c.33-.18,.45-.43,.31-.78-.06,.31-.15,.57-.31,.78Z"
            fill="#e2b291"
          />
          <path
            d="M159.12,224.65c2.45,.03,4.88,.14,7.17,.28-1.9-.17-3.98-.29-6.21-.29-.32,0-.64,0-.96,0Z"
            fill="#e2b291"
          />
        </g>
        <path
          id="_-24"
          d="M179.73,225.41c-6.28,3.29-13.3-.14-19.71-.09-6.46-.09-13.6,3.56-19.86,.11-1.34-.87-.21-3.1,1.19-2.27,2.45,1.9,5.9,1.66,8.87,1.39,3.19-.32,6.42-.99,9.79-1.02,3.38-.06,6.63,.76,9.8,1.12,3.06,.37,6.24,.28,8.94-1.4,1.33-.78,2.38,1.44,.99,2.16h0Z"
          fill="#b17f5e"
        />
      </g>
    </g>
    <g
      id="Mouth_A-13-7-3"
      v-if="data.value === 'type-21' && data.position === 'b'"
    >
      <g>
        <path
          d="M176.53,222.67c-.42-.47-.84-.91-1.26-1.32-7.29-7.19-12.62-4.2-15.18-2.55-.5,.32-1.13,.32-1.63,0-2.56-1.65-7.92-4.64-15.21,2.55-.49,.49-1,1.02-1.5,1.59-.09,.1-.18,.2-.26,.29-.01,.02-.03,.03-.04,.05-.01,.02-.02,.03-.03,.04-.65,.8-1.01,1.65-1.01,2.54,0,4.45,8.95,9.01,18.88,9.01s18.88-4.56,18.88-9.01c0-1.14-.59-2.22-1.62-3.2Z"
          fill="#ebb291"
        />
        <path
          d="M174.04,225.01c-.13-.59-.65-1.02-1.22-1.02-.21,0-.42,.06-.62,.16-1.12,.64-2.45,.94-4.08,.94-.57,0-1.17-.04-1.84-.11-.73-.07-1.45-.18-2.21-.29-1.42-.21-2.89-.42-4.41-.42h-.24c-1.57,.01-3.1,.2-4.58,.39-.74,.09-1.51,.19-2.26,.26-.72,.06-1.43,.11-2.15,.11-1.63,0-2.8-.29-3.67-.91-.02-.01-.03-.02-.05-.03-.21-.12-.44-.18-.66-.18-.58,0-1.11,.41-1.27,1.01-.16,.58,.08,1.17,.61,1.48,1.36,.69,2.85,1.01,4.6,1.01,1.59,0,3.21-.26,4.78-.52,1.56-.25,3.04-.5,4.49-.5h.26c1.44,0,2.91,.23,4.46,.47,1.56,.24,3.17,.5,4.75,.5,1.75,0,3.26-.31,4.6-.96,.56-.26,.84-.82,.71-1.4Zm-.49,.14c-.01-.06-.03-.11-.05-.16,.02,.05,.04,.11,.05,.16Zm-.09-.25c-.03-.05-.07-.1-.11-.15,.04,.05,.08,.1,.11,.15Zm-.17-.21c-.07-.06-.14-.11-.23-.14,.09,.03,.16,.08,.23,.14Zm-.26-.15c-.08-.03-.16-.04-.25-.04,.01,0,.02,0,.04,0,.08,0,.15,.02,.22,.04Zm-.61,.06c.11-.06,.21-.08,.31-.09-.1,.01-.2,.04-.31,.09-.3,.17-.6,.3-.91,.43,.31-.12,.62-.26,.91-.43Zm-5.05,.98c.2,.01,.41,.02,.61,.02-.2,0-.4,0-.61-.02Zm3.88-.46c-.25,.09-.51,.16-.78,.22,.26-.06,.52-.14,.78-.22Zm-.97,.27c-.32,.07-.65,.12-.98,.15,.33-.03,.66-.08,.98-.15Zm-1.22,.17c-.27,.02-.53,.03-.8,.04,.27,0,.53-.02,.8-.04Zm-1.97,0c-.29-.02-.58-.04-.87-.08,.29,.03,.58,.06,.87,.08Zm.63,1.28c-.11,0-.21-.01-.32-.02,.11,0,.21,.01,.32,.02Zm-1.17-.1c-.07,0-.13-.01-.2-.02,.07,0,.13,.01,.2,.02Zm-1.99-1.46c-.53-.08-1.06-.16-1.6-.23,.54,.07,1.07,.15,1.6,.23Zm-4.91-.5c.31,0,.61,.03,.92,.04-.39-.02-.77-.05-1.16-.04,.08,0,.16,0,.24,0Zm2.71,.2c-.37-.05-.73-.09-1.1-.12,.37,.03,.73,.08,1.1,.12Zm-9.74,.45c1.11-.1,2.22-.26,3.35-.39-1.13,.13-2.24,.29-3.35,.39-.31,.02-.62,.05-.94,.07,.32-.02,.63-.04,.94-.07Zm6.43,.49c-.26,0-.51,.01-.77,.03,.26-.02,.52-.03,.77-.03Zm-1.1,.05c-.28,.02-.55,.05-.83,.08,.28-.03,.56-.06,.83-.08Zm-1.03,.11c-.35,.04-.7,.09-1.05,.15,.35-.05,.7-.1,1.05-.15Zm-7.54-.58c.32,.03,.64,.04,.97,.04-.32,0-.65-.01-.97-.04Zm3.01,1.26c-.08,.01-.17,.02-.25,.03,.08,0,.17-.02,.25-.03Zm-1.06,.11c-.11,0-.22,.02-.33,.02,.11,0,.22-.01,.33-.02Zm-.7-1.33c.26,0,.52-.01,.77-.02-.26,.01-.51,.02-.77,.02Zm-3.36-.55c-.28-.12-.55-.27-.81-.45-.11-.06-.21-.09-.32-.1,.1,.01,.21,.04,.32,.1,.25,.18,.53,.32,.81,.45Zm2,.49c-.28-.03-.55-.07-.81-.12,.27,.05,.54,.1,.81,.12Zm-1.09-.19c-.22-.05-.43-.12-.64-.2,.21,.08,.42,.15,.64,.2Zm-2.09-.86c-.08,0-.16,0-.24,.03,.06-.02,.12-.03,.19-.03,.02,0,.03,0,.05,0Zm-.3,.04c-.09,.03-.17,.08-.24,.14,.07-.06,.15-.11,.24-.14Zm-.3,.2s-.1,.1-.13,.16c.04-.06,.08-.11,.13-.16Zm-.18,.25c-.03,.06-.05,.11-.06,.17,.01-.06,.04-.12,.06-.17Zm-.08,.28c0,.06,0,.12,0,.18,0-.06,0-.12,0-.18Zm.02,.29c.02,.06,.05,.12,.08,.18-.03-.06-.06-.12-.08-.18Zm.13,.27c.06,.08,.15,.16,.25,.23-.11-.06-.19-.14-.25-.23Zm1.22,.63c.1,.04,.2,.06,.3,.1-.1-.03-.2-.06-.3-.1Zm1,.28c.11,.02,.22,.05,.32,.07-.11-.02-.22-.04-.32-.07Zm1.1,.18c.08,0,.15,.02,.22,.03-.08,0-.15-.02-.22-.03Zm1.23,.07c.08,0,.16,0,.24,0-.06,0-.13,0-.19,0-.02,0-.03,0-.05,0Zm4.71-.5c.3-.05,.59-.09,.88-.14-.29,.05-.59,.09-.88,.14Zm-1.2,.19c.1-.01,.19-.03,.29-.05-.1,.02-.19,.03-.29,.05Zm9.75-.35c.3,.05,.6,.09,.9,.14-.3-.05-.6-.09-.9-.14Zm-3.53-.34c.28,0,.56,.01,.85,.03-.28-.02-.57-.03-.85-.03Zm1.17,.05c.26,.02,.52,.05,.78,.08-.26-.03-.52-.05-.78-.08Zm1.04,.1c.34,.04,.68,.09,1.03,.14-.34-.05-.68-.1-1.03-.14Zm3.43,.51c-.11-.02-.22-.03-.33-.05,.11,.02,.22,.03,.33,.05Zm3.22,.29c.09,0,.18,0,.27,0-.02,0-.04,0-.07,0-.07,0-.13,0-.2,0Zm3.61-.51c-.1,.03-.2,.06-.3,.09,.1-.03,.2-.06,.3-.09Zm-1.01,.27c-.11,.02-.21,.05-.32,.06,.11-.02,.21-.04,.32-.06Zm-1.13,.18c-.06,0-.12,.02-.18,.02,.06,0,.12-.02,.18-.02Zm3.12-.84c.11-.05,.2-.12,.27-.2-.07,.08-.15,.14-.27,.2Zm.43-.54c0-.06,.01-.11,.01-.17,0,.06,0,.11-.01,.17Zm-.11,.27c.04-.05,.07-.11,.09-.17-.02,.06-.05,.11-.09,.17Z"
          fill="#b17f5e"
        />
      </g>
    </g>
    <g
      id="Mouth_A-13-7-22"
      v-if="data.value === 'type-22' && data.position === 'b'"
    >
      <path
        fill="#b17f5e"
        d="m146.89,232.7c-.35,0-.69-.18-.87-.51-.27-.48-.1-1.09.39-1.36,3.66-2.04,8.49-3.16,13.62-3.16s9.96,1.12,13.62,3.16c.48.27.66.88.39,1.36-.27.48-.88.65-1.36.39-3.36-1.88-7.85-2.91-12.64-2.91s-9.28,1.03-12.64,2.91c-.15.09-.32.13-.49.13Z"
      />
    </g>
    <g
      id="Mouth_A-13-7-23"
      v-if="data.value === 'type-23' && data.position === 'b'"
    >
      <path
        fill="#b17f5e"
        d="m181.18,235.46c-.17,0-.33-.04-.49-.13-5.6-3.12-13.05-4.84-21-4.84s-15.4,1.72-21,4.84c-.48.27-1.09.1-1.36-.39-.27-.48-.1-1.09.39-1.36,5.89-3.28,13.69-5.09,21.97-5.09s16.08,1.81,21.97,5.09c.48.27.66.88.39,1.36-.18.33-.52.51-.87.51Z"
      />
    </g>
    <g
      id="Mouth_A-13-7-24"
      v-if="data.value === 'type-24' && data.position === 'b'"
    >
      <g>
        <path
          fill="#fff"
          d="m163.49,227.84l-4.25.78-4.46-.67c-1.42,0-2.27-.13-2.27,1.04v2.66c0,1.18,1.07,1.94,2.58,2.14l2.37.19c.69.05,1.3-.41,1.44-1.09l.35-1.78.35,1.79c.13.67.75,1.14,1.44,1.09l2.55-.2c1.41-.22,2.58-.96,2.58-2.14v-2.66c0-1.18-1.25-1.15-2.67-1.15Z"
        />
        <path
          fill="#bababa"
          d="m163.67,227.84c1.34,0,2.49.02,2.49,1.15v2.66c0,1.18-1.17,1.91-2.58,2.14l-2.55.2s-.07,0-.11,0c-.64,0-1.2-.45-1.33-1.09l-.35-1.79-.35,1.78c-.13.64-.69,1.09-1.33,1.09-.04,0-.07,0-.11,0l-2.37-.19c-1.51-.19-2.58-.96-2.58-2.14v-2.66c0-.96.57-1.05,1.55-1.05.22,0,.46,0,.72,0l4.46.67,4.25-.78h.18m0-.38h-.18c-.06,0-.12,0-.18.02l-4.09.75-4.3-.65s-.1-.01-.15-.01h-.38s-.34,0-.34,0c-.7,0-2.55-.62-2.55,1.43v2.66c0,1.63,1.35,2.86,3.45,3.13l2.42.19c.06,0,.12,0,.19,0,.65,0,1.24-.27,1.67-.7.43.44,1.03.72,1.69.72.06,0,.12,0,.19,0l2.55-.2s.05,0,.08,0c2.08-.33,3.42-1.56,3.42-3.13v-2.66c0-2.15-2.27-1.53-3.49-1.53h0Z"
        />
      </g>
      <path
        fill="#b17f5e"
        d="m145.43,223.72c3.6,5.28,23.72,5.3,27.68.27.93-1.88,3.74-.16,2.45,1.62-6.8,4.83-20.6,4.73-28.3,2.08-1.44-.54-2.9-1.04-4.13-2.05-1.23-1.54,1.01-3.41,2.31-1.92h0Z"
      />
    </g>
    <g
      id="Mouth_A-13-7-25"
      v-if="data.value === 'type-25' && data.position === 'b'"
    >
      <path
        fill="#e26a87"
        d="m157.41,226.45c1.35-1.28,3.67-.57,5.38,1.29s.9,4.93-.9,5.26c-4.82.89-5.85-5.25-4.47-6.56Z"
      />
    </g>
    <g
      id="Mouth_A-13-7-26"
      v-if="data.value === 'type-26' && data.position === 'b'"
    >
      <path
        fill="#ec9595"
        d="m173.81,226.73c-.12-.62-.73-1.03-1.34-.92-.62.12-1.03.72-.92,1.34.06.3.08.77-.43,1.31-.97,1.03-3.13,1.58-5.13,1.34-2.42-.31-4.22-1.93-5.18-2.81-.31-.28-.51-.47-.72-.6-.21-.13-.45-.17-.68-.15-.28-.05-.58-.01-.83.15-.21.13-.41.32-.72.6-.97.87-2.76,2.5-5.18,2.81-2,.25-4.16-.31-5.13-1.34-.5-.54-.49-1-.43-1.31.12-.62-.29-1.23-.92-1.34-.62-.11-1.23.29-1.34.92-.23,1.2.13,2.38,1.01,3.31,1.25,1.33,3.49,2.12,5.82,2.12.42,0,.85-.03,1.28-.08,3.08-.39,5.28-2.34,6.37-3.33,1.09.99,3.29,2.94,6.37,3.33.42.05.85.08,1.28.08,2.33,0,4.57-.79,5.82-2.12.88-.94,1.24-2.11,1.01-3.31Z"
      />
    </g>
    <g
      id="Mouth_A-13-7-27"
      v-if="data.value === 'type-27' && data.position === 'b'"
    >
      <path
        fill="#ffd0b0"
        d="m171.05,229.9c0,4.34-4.95,7.85-11.05,7.85s-11.05-3.51-11.05-7.85c0-1.76.81-3.38,2.19-4.69,2.01-1.92,5.23-4.83,8.86-4.83,3.81,0,7.17,3.04,9.16,5.13,1.19,1.25,1.89,2.76,1.89,4.39Z"
      />
      <path
        fill="#b17f5e"
        d="m163.8,227.54c0,1.35-1.7,1.84-3.8,1.84s-3.8-.53-3.8-1.84,1.7-2.42,3.8-2.42,3.8,1.11,3.8,2.42Z"
      />
      <path
        fill="#e2b89c"
        d="m160.08,238.71c-4.74,0-7.32-2.61-7.47-2.71-.29-.2-.15-.5.15-.7s.74-.1,1.03.1c0,0,1.89,1.2,5.28,1.4,2.79,0,5.03.1,7.24-1.3.29-.2.74-.2,1.03,0s0,.7,0,.7c0,0-2.52,2.51-7.26,2.51Z"
      />
    </g>
  </fragment>
</template>

<script>
export default {
  name: 'avatarMouthA',
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
}
</script>
